"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FillClaimButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _actions = require("../../store/actions");
var _checkList = _interopRequireDefault(require("./check-list.svg"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledButton = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :hover {\n      color: ", "\n    }\n    :hover path {\n        fill: ", " !important;\n    }\n"])), function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.primaryColor;
});
var FillClaimButton = exports.FillClaimButton = function FillClaimButton(_ref) {
  var offerID = _ref.offerID;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('WIDGETS'),
    t = _useTranslation.t;
  var onClick = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.fillClaim)(offerID));
  }, [dispatch, offerID]);
  return /*#__PURE__*/_react.default.createElement(StyledButton, {
    className: _styles.default.root,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.icon,
    dangerouslySetInnerHTML: {
      __html: _checkList.default
    }
  }), t('FILL_CLAIM_BUTTON'));
};
FillClaimButton.propTypes = {
  offerID: _propTypes.default.string.isRequired
};